<div *ngIf="!isEdited" class="cell-view">
  <i *ngIf="rowData[fieldName]" class="pi pi-check"></i>
  <i *ngIf="!rowData[fieldName]" class="pi pi-times"></i>
  <div *ngIf="editable" class="edit-menu">
    <button
      pButton
      id="cancelRowSelection"
      data-cy="BoolCell_Button_edit"
      icon="pi pi-pencil"
      (click)="onEdit()"
    ></button>
    <button
      pButton
      *ngIf="!mandatory && rowData[fieldName] != null"
      id="cancelRowSelection"
      data-cy="BoolCell_Button_cancel"
      icon="pi pi-trash"
      (click)="onDelete()"
    ></button>
  </div>
</div>

<ng-container *ngIf="isEdited">
  <ng-container *ngIf="showInputAsOverlay(minWidthPx); else woOverlay">
    <jml-lib-overlay [visible]="true" [widthPx]="2 * minWidthPx" overlayCssClass="p-1">
      <ng-container *ngTemplateOutlet="inputTpl"></ng-container>
    </jml-lib-overlay>
  </ng-container>
</ng-container>

<ng-template #woOverlay>
  <ng-container *ngTemplateOutlet="inputTpl"></ng-container>
</ng-template>

<ng-template #inputTpl>
  <div>
    <p-checkbox
      [name]="fieldName"
      [binary]="true"
      [(ngModel)]="rowData[fieldName]"
      ngClass="center-checkbox"
      (keyup.esc)="abortCellEdit($event)"
      (onChange)="isEdited = false; completeCellEdit.emit({ data: rowData, field: fieldName })"
      (clickOutside)="abortCellEdit($event)"
      (click)="$event.stopPropagation()"
      jmlAutoFocus
      jmlStopClickPropagation
      jmlClickOutside
    ></p-checkbox>
  </div>
</ng-template>
